export default __webpack_public_path__ + "static/media/JungleLife_12.fb6558a0.png";